import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';
import Loading from '../../Common/components/Loading';
import useFeatureFlagManagment from './hooks/useFeatureFlagManagement';
import RoleFeatureFlagAssociationInput from './RoleFeatureFlagAssociationInput';

export default function EditRoleFeatureFlagAssociation() {
    const { id, name } = useParams();

    const {
        isLoading,
        setIsLoading,
        getFeatureFlagsForRole,
        fetchFeatureFlags,
    } = useFeatureFlagManagment();

    const [associations, setAssociations] = useState<any[]>([]);
    const [featureFlags, setFeatureFlags] = useState<any[]>([]);

    useEffect(() => {
        let isMounted = true;
        const load = async () => {
            try {
                const associations = await getFeatureFlagsForRole(
                    id ? +id : -1,
                );
                const featureFlags = await fetchFeatureFlags();

                isMounted && setAssociations(associations);
                isMounted && setFeatureFlags(featureFlags);
            } catch (error) {
                console.error('Failed to load assocaiations', error);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        load();
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return <Loading isLoading={isLoading} />;
    }

    return (
        <div className="p-4">
            <div className="Row-container">
                <h1 className="text-2xl font-bold capitalize">
                    {name} role association
                </h1>
            </div>
            <table className="Table mt-4">
                <thead>
                    <tr>
                        <th>Feature Flag</th>
                        <th>Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    {featureFlags.map((flag) => {
                        return (
                            <tr>
                                <td>{flag.key}</td>
                                <td>
                                    <RoleFeatureFlagAssociationInput
                                        checked={associations.includes(
                                            flag.key,
                                        )}
                                        roleId={id ? +id : -1}
                                        keyId={flag.id}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <br />
            <div className="mt-6 flex items-center justify-end gap-x-6 px-6 fixed bottom-0 left-0 right-0 z-50 border-t border-gray-900/10 bg-white p-3 ">
                <NavLink
                    to="/admin/features"
                    className="rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                >
                    <span>Done</span>
                </NavLink>
            </div>
        </div>
    );
}
